import * as React from 'react';
import { Link, graphql } from 'gatsby';
import fontawesome from '@fortawesome/fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import Seo from '../components/seo';
import { PRODUCT_FILTERS } from '../constants/products-constants';

fontawesome.library.add(faSearch);

const SearchBox = ({ searchInput, onSearchInput, onSearch }) => {
  return (
    <form className="input-group rounded" onSubmit={onSearch}>
      <input type="search" className="form-control rounded" placeholder="Search" value={searchInput} aria-label="Search" aria-describedby="search-addon" onChange={onSearchInput} />
      <span className="input-group-text border-0" id="search-addon">
        <FontAwesomeIcon icon="search" />
      </span>
    </form>
  );
}

const ProductsPage = class ProductsPage extends React.Component {
  constructor({ data, location, activeSearchFilter = '' }) {
    super();

    const products = data.allWpProduct.edges.map(({ node }) => {
      return {
        slug: node.slug,
        title: node.title,
        productImageUrl: node.featuredImage?.node?.mediaItemUrl,
        productDescription: node.content,
        tags: node.categories?.nodes?.map(_ => _.slug) || []
      };
    });

    this.state = {
      activeFilter: Object.keys(PRODUCT_FILTERS)[0],
      activeSearchFilter,
      searchInput: activeSearchFilter,
      data,
      location,
      products
    };
  }

  onSetActiveFilter = activeFilter => {
    this.setState({
      activeFilter,
      activeSearchFilter: '',
      searchInput: ''
    });
  }

  onSearch = event => {
    event.preventDefault();
    this.setState({
      activeFilter: 'ALL',
      activeSearchFilter: this.state.searchInput
    });
  }

  onSearchInput = event => {
    event.preventDefault();
    this.setState({ searchInput: event.target.value });
  }

  render() {
    const pageTitle = 'Products';

    return (
      <div>
        <Seo title={pageTitle} />
        <ProductsIndex
          products={this.state.products}
          searchInput={this.state.searchInput}
          activeSearchFilter={this.state.activeSearchFilter}
          activeFilter={this.state.activeFilter}
          onSearch={this.onSearch}
          onSearchInput={this.onSearchInput}
          onSetActiveFilter={this.onSetActiveFilter}
        />
      </div>
    );
  }
};

export default ProductsPage;

const ProductsIndex = ({
  products,
  searchInput,
  activeSearchFilter,
  activeFilter,
  onSearch,
  onSearchInput,
  onSetActiveFilter
}) => {
  return (
    <div className="container mt-5 pb-5">
      <div className="row">
        <aside className="col-12 col-md-4 col-lg-3">
          <ul className="list-group mb-3">
            <li key="fast-product-selection-table" className="list-group-item list-group-item-action btn">
              {/* TODO: Move to WP page & replace with reference to REPLACE WITH CORRECT URL TO http://localhost/wordpress/wp-content/uploads/2022/07/Fast-Product-Selection-Table.pdf */}
              <a class="text-dark text-decoration-none" href="https://linearsystems.com/lsdata/datasheets/Fast%20Product%20Selection%20Table.pdf">
                Fast Product Selection Table
              </a>
            </li>
            <li key="spice-model-library-download" className="list-group-item list-group-item-action btn">
              {/* TODO: Move to WP page & replace with reference to  http://localhost/wordpress/wp-content/uploads/2022/07/Spice-Model-Library-Download_3_2020.txt */}
              <a class="text-dark text-decoration-none" href="https://linearsystems.com/lsdata/spicemodel/Spice%20Model%20Library%20Download_3_2020.txt">
                SPICE Model Library Download
              </a>
            </li>
          </ul>

          <div className="mb-3">
            <SearchBox searchInput={searchInput} onSearchInput={onSearchInput} onSearch={onSearch} />
          </div>

          <ul className="list-group mb-3">
            {Object.entries(PRODUCT_FILTERS).map(([filterCode, filter]) => {
              const isActiveFilter = filterCode === activeFilter;

              return (
                <li
                  key={filterCode}
                  onClick={() => onSetActiveFilter(filterCode)}
                  className={`list-group-item list-group-item-action btn ${ isActiveFilter ? 'active' : '' }`}
                  aria-current={isActiveFilter ? 'true' : 'false'}
                >
                  {filter.name}
                </li>
              );
            })}
          </ul>

          {/* TODO: Make these link to the correct contents (after the Products WP page has been created) */}
          <ul className="list-group mb-3">
            <li key="lead-free-rohs-fact-sheet" className="list-group-item list-group-item-action btn">Lead-free / RoHS Fact Sheet</li>
            <li key="lead-free-rohs-compliant-parts-list" className="list-group-item list-group-item-action btn">Lead-free / RoHS Compliant Parts List</li>
          </ul>
        </aside>

        <div className="col">
          <div className="container">
            { !!activeSearchFilter ? <div class="row"><div class="col h4 mb-3">Searching for "{activeSearchFilter}"</div></div> : <div></div>}
            <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 row-cols-xl-5 g-3">
              {products
                .filter(product => {
                  const filterTags = (PRODUCT_FILTERS[activeFilter].tags || []).filter(Boolean);
                  const productTags = (product.tags || []).filter(Boolean);
                  if (filterTags.length > 0) {
                    return filterTags.some(filterTag => productTags.includes(filterTag));
                  } else {
                    return true;
                  }
                })
                .filter(product => {
                  if (activeSearchFilter) {
                    const productTitle = product.title.toLowerCase();
                    const productDescription = product.description.toLowerCase();
                    return productTitle.includes(activeSearchFilter) || productDescription.includes(activeSearchFilter);
                  } else {
                    return true;
                  }
                })
                .map(product => {
                  const slug = product.slug;
                  const title = product.title || slug;
                  const productImageUrl = product.productImageUrl;

                  return (
                    <div className="col" key={slug}>
                      <Link to={slug} itemProp="url" className="text-dark text-decoration-none">
                        <div className="card">
                          <img className="card-img-top img-fluid px-3" src={productImageUrl} alt={title} />
                          <div className="card-body">
                            <span className="card-title">{title}</span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const pageQuery = graphql`
  query ProductsPageQuery {
    wp {
      allSettings {
        generalSettingsTitle
      }
    }
    allWpProduct {
      edges {
        node {
          slug
          title
          content
          featuredImage {
            node {
              mediaItemUrl
            }
          }
          categories {
            nodes {
              slug
              name
            }
          }
        }
      }
    }
  }
`;
